import React, { useRef, useState } from 'react';
import { forgotPassword } from '../services/auth.service';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import Button from '../components/Button';
import { Turnstile, TurnstileInstance } from '@marsidev/react-turnstile';
import Feedback from '../components/Feedback';

const ForgottenPassword: React.FC = () => {
  const [emailAddress, setEmailAddress] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState([] as string[]);
  const [challengeResponseCode, setChallengeResponseCode] = useState<string>();

  const navigate = useNavigate();

  const turnstileRef = useRef<TurnstileInstance | null>(null);

  const { isLoggedIn } = useAuth();

  const handleLogin = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setErrors([]);
    setMessage('');
    setLoading(true);
    const result = await forgotPassword(
      emailAddress,
      challengeResponseCode ?? ''
    );
    if (result.success) {
      setMessage(
        'Please check your emails for instructions about how to log in'
      );
    } else {
      setErrors(result.errors);
    }
    turnstileRef.current?.reset();
    turnstileRef.current?.render();
    setChallengeResponseCode('');
    setLoading(false);
  };

  const validTurnstyle = (e: string) => {
    setChallengeResponseCode(e);
  };

  if (isLoggedIn) {
    return <></>;
  }

  return (
    <div>
      <h2>Reset your password</h2>
      <form onSubmit={handleLogin} className="login-form">
        <p>
          Enter your email address and we will send you instructions to reset
          your password.
        </p>
        <input
          type="text"
          id="username"
          placeholder="Email Address"
          required
          value={emailAddress}
          onChange={(e) => setEmailAddress(e.target.value)}
        />
        <Turnstile
          siteKey={`${process.env.REACT_APP_TURNSTYLE_SITE}`}
          onSuccess={(e) => validTurnstyle(e)}
          options={{ theme: 'light', appearance: 'always' }}
          ref={turnstileRef}
        />
        <div className="button-container">
          <Button
            isLoading={loading}
            isSubmit={true}
            disabled={!challengeResponseCode}
          >
            Reset Password
          </Button>
          <Button type="Outline" onClick={() => navigate('/Account/Login')}>
            Cancel
          </Button>
        </div>
        <Feedback messages={errors} type="error" />
        <Feedback message={message} type="success" />
      </form>
    </div>
  );
};

export default ForgottenPassword;
